import { defineMessage } from "react-intl";

export const UNKNOWN_GROUP = "UNKNOWN_GROUP";

export const UNKNOWN_GROUP_MESSAGE = defineMessage({
  defaultMessage: "Others",
  description: "UNKNOWN_GROUP",
});
